<template>
    <div class="intelligence-chart">
        <h3 class="intelligence-chart__title">{{ $t('pages.intelligence.delivery.charts.by_channel') }}</h3>
        <div v-if="hasData" class="intelligence-chart__body">
            <apexchart type="bar" height="280" :options="chartOptions" :series="series"></apexchart>
        </div>
        <p v-else class="intelligence-chart__empty">{{ $t('pages.intelligence.delivery.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            channels: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            hasData() {
                return this.channels.some((row) => row.attempts > 0 || row.confirmed > 0)
            },

            series() {
                return [
                    {
                        name: this.$t('pages.intelligence.delivery.table.attempts'),
                        data: this.channels.map((row) => row.attempts),
                    },
                    {
                        name: this.$t('pages.intelligence.delivery.table.confirmed'),
                        data: this.channels.map((row) => row.confirmed),
                    },
                ]
            },

            chartOptions() {
                return {
                    chart: {
                        type: 'bar',
                        toolbar: { show: false },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            columnWidth: '55%',
                        },
                    },
                    colors: ['#1e3a8a', '#059669'],
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: this.channels.map((row) => row.channel),
                    },
                    legend: {
                        position: 'top',
                    },
                    grid: {
                        borderColor: '#e5e7eb',
                    },
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-chart {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-chart__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-chart__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
